
import { 
  EpDevPAssetsApiRoutesFactory,
  EpDevPAssetsApiPathsFactory,
  EpDevPUtils,
  TEpDevPApiManageAssetBasePathParams,
  EpDevPAsyncApiFormat,
  EpDevPAsyncApiVersion
} from '@solace-labs/backstage-plugin-ep-devp-common';

const DOMAINS = "domains";
const CREDENTIALS = "credentials";
const CONTACT_INFO = "contact-info";
const CONSUMER_PRODUCT_REGISTRATIONS = "consumer-product-registrations";
const ACCESS_REQUESTS = "access-requests";
const EVENT_APIS = "event-apis";
const ASYNC_APIS = "async-apis";

type TEpDevPApiCredentialsBasePathParams = TEpDevPApiManageAssetBasePathParams;
export type TEpDevPApiListCredentialsPathParams = TEpDevPApiCredentialsBasePathParams;
export type TEpDevPApiCreateCredentialsPathParams = TEpDevPApiCredentialsBasePathParams;
export type TEpDevPApiDeleteCredentialsPathParams = TEpDevPApiCredentialsBasePathParams & {
  credentialsId: string;
}
export type TEpDevPApiUpdateContactInfoPathParams = TEpDevPApiManageAssetBasePathParams;

type TEpDevPApiConsumerProductRegistrationsBasePathParams = TEpDevPApiManageAssetBasePathParams;
export type TEpDevPApiListConsumerProductRegistrationsPathParams = TEpDevPApiConsumerProductRegistrationsBasePathParams;
export type TEpDevPApiCreateConsumerProductRegistrationsPathParams = TEpDevPApiConsumerProductRegistrationsBasePathParams;
export type TEpDevPApiUpgradeConsumerProductRegistrationsPathParams = TEpDevPApiConsumerProductRegistrationsBasePathParams;
export type TEpDevPApiDeleteConsumerProductRegistrationsPathParams = TEpDevPApiConsumerProductRegistrationsBasePathParams & {
  accessRequestId: string;
}
// event apis
export type TEpDevPApiListEventApisPathParams = TEpDevPApiManageAssetBasePathParams;
export type TEpDevPApiListEventApisQueryParams = {
  accessRequestId?: string;
}
export type TEpDevPApiGetAsyncApiPathParams = TEpDevPApiManageAssetBasePathParams & {
  accessRequestId: string;
  eventApiId: string;
}
export type TEpDevPApiGetAsyncApiQueryParams = {
  format: EpDevPAsyncApiFormat,
  asyncApiVersion: EpDevPAsyncApiVersion;
  fileNamePathForZip?: string;
}


export class EpDevPConsumerAppsApiRoutesFactory extends EpDevPAssetsApiRoutesFactory {

  public static getSubRouteListConsumerAppDomains = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.getSubRouteBase()}/${DOMAINS}`;
  }
  public static getSubRouteListCredentials = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CREDENTIALS}`;
  }
  public static postSubRouteCreateCredentials = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CREDENTIALS}`;
  }
  public static deleteSubRouteDeleteCredentials = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CREDENTIALS}/:${EpDevPUtils.nameOf<TEpDevPApiDeleteCredentialsPathParams>("credentialsId")}`;
  }
  public static postSubRouteUpdateContactInfo = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CONTACT_INFO}`;
  }
  public static getSubRouteListConsumerProductRegistrations = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CONSUMER_PRODUCT_REGISTRATIONS}`;
  }
  public static postSubRouteCreateConsumerProductRegistration = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CONSUMER_PRODUCT_REGISTRATIONS}`;
  }
  public static patchSubRouteUpgradeConsumerProductRegistration = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CONSUMER_PRODUCT_REGISTRATIONS}`;
  }
  public static deleteSubRouteDeleteConsumerProductRegistration = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${CONSUMER_PRODUCT_REGISTRATIONS}/:${EpDevPUtils.nameOf<TEpDevPApiDeleteConsumerProductRegistrationsPathParams>("accessRequestId")}`;
  }
  public static getSubRouteListEventApis = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${EVENT_APIS}`;
  }
  public static getSubRouteGetAsyncApi = (): string => {
    return `${EpDevPConsumerAppsApiRoutesFactory.subRouteManageAsset()}/${ACCESS_REQUESTS}/:${EpDevPUtils.nameOf<TEpDevPApiGetAsyncApiPathParams>("accessRequestId")}/${EVENT_APIS}/:${EpDevPUtils.nameOf<TEpDevPApiGetAsyncApiPathParams>("eventApiId")}/${ASYNC_APIS}`;
  }
}

export class EpDevPConsumerAppsApiPathsFactory extends EpDevPAssetsApiPathsFactory {

  public static listConsumerAppDomainsPath({ organizationId }:{
    organizationId: string;
  }): string {
    return `/${organizationId}/${DOMAINS}`;
  }

  private static credentialsBasePath({ organizationId, domainId, appId }:{
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return `${EpDevPConsumerAppsApiPathsFactory.managedAssetPath({ organizationId, domainId, assetId: appId })}/${CREDENTIALS}`;
  }

  public static listCredentialsPath({ organizationId, domainId, appId }:{
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return EpDevPConsumerAppsApiPathsFactory.credentialsBasePath({ organizationId, domainId, appId });
  }

  public static createCredentialsPath({ organizationId, domainId, appId }:{
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return EpDevPConsumerAppsApiPathsFactory.credentialsBasePath({ organizationId, domainId, appId });
  }

  public static deleteCredentialsPath({ organizationId, domainId, appId, credentialsId }:{
    organizationId: string;
    domainId: string;
    appId: string;
    credentialsId: string;
  }): string {
    return `${EpDevPConsumerAppsApiPathsFactory.credentialsBasePath({ organizationId, domainId, appId })}/${credentialsId}`;
  }

  public static updateContactInfoPath({ organizationId, domainId, appId }: {
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return `${EpDevPConsumerAppsApiPathsFactory.managedAssetPath({ organizationId, domainId, assetId: appId })}/${CONTACT_INFO}`;
  }

  private static consumerProductRegistrationsBasePath({ organizationId, domainId, appId }:{
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return `${EpDevPConsumerAppsApiPathsFactory.managedAssetPath({ organizationId, domainId, assetId: appId })}/${CONSUMER_PRODUCT_REGISTRATIONS}`;
  }

  public static listConsumerProductRegistrationsPath({ organizationId, domainId, appId }:{
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return EpDevPConsumerAppsApiPathsFactory.consumerProductRegistrationsBasePath({ organizationId, domainId, appId });
  }

  public static createConsumerProductRegistrationPath({ organizationId, domainId, appId }:{
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return EpDevPConsumerAppsApiPathsFactory.consumerProductRegistrationsBasePath({ organizationId, domainId, appId });
  }

  public static upgradeConsumerProductRegistrationPath({ organizationId, domainId, appId }:{
    organizationId: string;
    domainId: string;
    appId: string;
  }): string {
    return EpDevPConsumerAppsApiPathsFactory.consumerProductRegistrationsBasePath({ organizationId, domainId, appId });
  }

  public static deleteConsumerProductRegistrationPath({ organizationId, domainId, appId, accessRequestId }:{
    organizationId: string;
    domainId: string;
    appId: string;
    accessRequestId: string;
  }): string {
    return `${EpDevPConsumerAppsApiPathsFactory.consumerProductRegistrationsBasePath({ organizationId, domainId, appId })}/${accessRequestId}`;
  }

  public static getListEventApisPath({ organizationId, domainId, appId, accessRequestId }:{
    organizationId: string;
    domainId: string;
    appId: string;
    accessRequestId?: string; /** if undefined, returns event apis for all accessRequestIds */
  }): string {
    const queryParams: string[] = [];
    if(accessRequestId) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiListEventApisQueryParams>("accessRequestId")}=${accessRequestId}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `${EpDevPConsumerAppsApiPathsFactory.managedAssetPath({ organizationId, domainId, assetId: appId })}/${EVENT_APIS}?${queryString}`;
  }

  public static getAsyncApiPath({ organizationId, domainId, appId, accessRequestId, eventApiId, format, asyncApiVersion, fileNamePathForZip }:{
    organizationId: string;
    domainId: string;
    appId: string;
    accessRequestId: string;
    eventApiId: string;
    format: EpDevPAsyncApiFormat;
    asyncApiVersion: EpDevPAsyncApiVersion;
    fileNamePathForZip?: string;
  }): string {
    const queryParams: string[] = [];
    queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiGetAsyncApiQueryParams>("format")}=${format}`);
    queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiGetAsyncApiQueryParams>("asyncApiVersion")}=${asyncApiVersion}`);
    if(fileNamePathForZip) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiGetAsyncApiQueryParams>("fileNamePathForZip")}=${fileNamePathForZip}`);    
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `${EpDevPConsumerAppsApiPathsFactory.managedAssetPath({ organizationId, domainId, assetId: appId })}/${ACCESS_REQUESTS}/${accessRequestId}/${EVENT_APIS}/${eventApiId}/${ASYNC_APIS}?${queryString}`;
  }

}

